// Slug a subject-area name for use as a DOM id.
// "Business Law and Practice" → "business-law-and-practice"
export function subjectSlug(name) {
  return String(name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}
